import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function ScheduleIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="83"
      viewBox="0 0 80 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_5011)">
        <path
          d="M65.1213 82.8033H14.8787C11.6442 82.8033 9.05664 80.2157 9.05664 76.9812V8.40975C9.05664 5.17525 11.6442 2.58765 14.8787 2.58765H65.1213C68.3558 2.58765 70.9434 5.17525 70.9434 8.40975V76.7655C70.9434 80.2157 68.3558 82.8033 65.1213 82.8033Z"
          fill="#EAEEF9"
        />
        <path
          d="M65.337 82.8032H14.4475C11.4286 82.8032 9.05664 80.4312 9.05664 77.4123V76.9811H70.9434C70.9434 80.2156 68.3558 82.8032 65.337 82.8032Z"
          fill="#00C4B3"
        />
        <path
          d="M70.9434 23.0728H9.05664V6.25337C9.05664 2.80323 11.8599 0 15.31 0H64.6901C68.1402 0 70.9434 2.80323 70.9434 6.25337V23.0728Z"
          fill="#EAEEF9"
        />
        <path
          d="M40.3234 70.2965C39.4609 70.2965 38.814 69.6496 38.814 68.7871V49.1645C38.814 48.3019 39.4609 47.655 40.3234 47.655H62.1024C62.9649 47.655 63.6118 48.3019 63.6118 49.1645V69.0027C63.6118 69.8653 62.9649 70.5122 62.1024 70.5122H40.3234V70.2965Z"
          fill="white"
        />
        <path
          d="M62.3181 46.3612H40.3235C38.8141 46.3612 37.5203 47.655 37.5203 49.3801V69.0027C37.5203 70.5122 38.8141 72.0216 40.3235 72.0216H62.1025C63.6119 72.0216 65.1213 70.7278 65.1213 69.0027V49.3801C65.1213 47.655 63.8275 46.3612 62.3181 46.3612ZM62.3181 69.0027H40.3235V49.3801H62.1025V69.0027H62.3181Z"
          fill="#00416B"
        />
        <path
          d="M16.3882 82.8033V49.1645C16.3882 48.3019 17.0351 47.655 17.8976 47.655H28.8949C29.7575 47.655 30.4044 48.3019 30.4044 49.1645V82.5876H16.3882V82.8033Z"
          fill="white"
        />
        <path
          d="M28.6792 46.3612H17.8975C16.3881 46.3612 14.8787 47.655 14.8787 49.3801V82.8033H17.8975V49.1644H28.8948V82.5876H31.9137V49.1644C31.6981 47.655 30.4043 46.3612 28.6792 46.3612Z"
          fill="#00416B"
        />
        <path
          d="M9.48787 39.8922H6.469C2.80323 39.8922 0 36.8734 0 33.4232H15.9569C15.9569 36.8734 13.1536 39.8922 9.48787 39.8922Z"
          fill="#00416B"
        />
        <path
          d="M25.4448 39.8922H22.4259C18.7601 39.8922 15.9569 36.8734 15.9569 33.4232H31.9138C32.1294 36.8734 29.1105 39.8922 25.4448 39.8922Z"
          fill="#00C4B3"
        />
        <path
          d="M41.4016 39.8922H38.3827C34.7169 39.8922 31.9137 36.8734 31.9137 33.4232H47.8706C48.0862 36.8734 45.0673 39.8922 41.4016 39.8922Z"
          fill="#00416B"
        />
        <path
          d="M57.5742 39.8922H54.5553C50.8895 39.8922 48.0863 36.8734 48.0863 33.4232H64.0432C64.0432 36.8734 61.0243 39.8922 57.5742 39.8922Z"
          fill="#00C4B3"
        />
        <path
          d="M73.531 39.8922H70.5121C66.8463 39.8922 64.0431 36.8734 64.0431 33.4232H80C80 36.8734 77.1967 39.8922 73.531 39.8922Z"
          fill="#00416B"
        />
        <path
          d="M70.9434 23.0728H59.2992L64.0431 33.2075H80L70.9434 23.0728Z"
          fill="#00416B"
        />
        <path
          d="M20.7008 23.0728L15.9569 33.2075H32.1294L34.0701 23.0728H20.7008Z"
          fill="#00C4B3"
        />
        <path
          d="M45.9299 23.0728L48.0863 33.2075H64.0431L59.2992 23.0728H45.9299Z"
          fill="#00C4B3"
        />
        <path
          d="M9.0566 23.0728L0 33.2075H15.9569L20.7008 23.0728H9.0566Z"
          fill="#00416B"
        />
        <path
          d="M34.0701 23.0728L32.1294 33.2075H48.0863L45.9299 23.0728H34.0701Z"
          fill="#00416B"
        />
        <path
          d="M64.9056 8.84094C64.0431 8.84094 63.1805 9.48784 63.1805 10.566C63.1805 11.6442 63.8274 12.2911 64.9056 12.2911C65.9838 12.2911 66.6307 11.6442 66.6307 10.566C66.6307 9.48784 65.7681 8.84094 64.9056 8.84094ZM64.4743 10.1347C64.2587 10.1347 64.2587 10.3504 64.2587 10.3504V10.7816H64.0431V9.91911H64.2587H64.4743V10.1347ZM65.9838 10.566V11.2129H65.7681V10.566C65.7681 10.3504 65.5525 10.3504 65.5525 10.3504C65.3369 10.3504 65.3369 10.566 65.3369 10.566V11.2129H65.1212V9.27221H65.3369V9.91911H65.5525C65.7681 9.91911 65.9838 10.1347 65.9838 10.566Z"
          fill="#00C4B3"
        />
        <path
          d="M37.3046 10.7816C38.3827 10.7816 39.2453 11.6442 39.2453 12.7223C39.2453 13.8005 38.3827 14.663 37.3046 14.663C36.2264 14.663 35.3639 13.8005 35.3639 12.7223C35.1482 11.6442 36.0108 10.7816 37.3046 10.7816ZM37.3046 8.84094C35.1482 8.84094 33.2075 10.566 33.2075 12.938C33.2075 15.0943 34.9326 17.035 37.3046 17.035C39.4609 17.035 41.4016 15.3099 41.4016 12.938C41.186 10.566 39.4609 8.84094 37.3046 8.84094Z"
          fill="#00416B"
        />
        <path
          d="M30.4043 16.8194H28.2479L25.4447 8.84094H27.8167L29.3261 13.8005L31.0512 8.84094H33.2075L30.4043 16.8194Z"
          fill="#00416B"
        />
        <path
          d="M50.8895 16.8194H48.7332L45.9299 8.84094H48.3019L49.8113 13.8005L51.5364 8.84094H53.6927L50.8895 16.8194Z"
          fill="#00416B"
        />
        <path
          d="M25.6604 13.5849V12.938C25.6604 10.7817 23.9353 9.05664 21.5633 9.05664C19.407 9.05664 17.4663 10.7817 17.4663 13.1537C17.4663 15.31 19.1914 17.2507 21.5633 17.2507C22.6415 17.2507 23.7197 16.8194 24.5822 15.9569L23.0728 14.4475C22.6415 14.8787 22.2102 15.0944 21.5633 15.0944C20.7008 15.0944 20.0539 14.6631 19.6226 13.8006L25.6604 13.5849ZM21.5633 10.7817C22.4259 10.7817 23.0728 11.213 23.504 12.0755H19.6226C20.0539 11.4286 20.7008 10.7817 21.5633 10.7817Z"
          fill="#00416B"
        />
        <path
          d="M61.8868 13.5849V12.938C61.8868 10.7817 60.1618 9.05664 57.7898 9.05664C55.6334 9.05664 53.6927 10.7817 53.6927 13.1537C53.6927 15.31 55.4178 17.2507 57.7898 17.2507C58.8679 17.2507 59.9461 16.8194 60.8087 15.9569L59.2992 14.4475C58.868 14.8787 58.4367 15.0944 57.7898 15.0944C56.9272 15.0944 56.2803 14.6631 55.8491 13.8006L61.8868 13.5849ZM57.7898 10.7817C58.6523 10.7817 59.2992 11.213 59.7305 12.0755H56.0647C56.2804 11.4286 56.9272 10.7817 57.7898 10.7817Z"
          fill="#00416B"
        />
        <path
          d="M44.2049 12.938V4.52832H42.2642V12.7224C42.2642 14.8787 43.9892 16.6038 46.1456 16.6038V14.8787C45.0674 14.6631 44.2049 13.8006 44.2049 12.938Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_5011">
          <rect width="80" height="82.8032" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
